/**
 * Resolve a logomarca conforme o tema activo.
 * Preferência: variante do tema → logo legada → outra variante.
 */
export function resolveBrandLogoUrl(branding = {}, theme = "light") {
  const light = branding.logo_url_light || branding.logo_url || "";
  const dark = branding.logo_url_dark || branding.logo_url || "";
  if (theme === "dark") {
    return dark || light || "";
  }
  return light || dark || "";
}

export default resolveBrandLogoUrl;
